import { render, staticRenderFns } from "./Waivers.vue?vue&type=template&id=95c8eb8c&scoped=true&"
import script from "./Waivers.vue?vue&type=script&lang=js&"
export * from "./Waivers.vue?vue&type=script&lang=js&"
import style0 from "./Waivers.vue?vue&type=style&index=0&id=95c8eb8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c8eb8c",
  null
  
)

export default component.exports